import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {V2L2WorkItemDetailContent, V2L2WorkItemDetailRoot, V2L2WorkItemDetailTitle } from "./V2L2WorkItemDetail"
import { V2L2WorkItemDetailContentItem } from "./V2L2WorkItemDetailContentItem"
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
import { FusionError } from '@fusion-advantage/backcompat'

const ErrorBlock = styled.pre(({theme}) => ({
	...theme.fonts.mono,
	fontSize: `${12/16}rem`,
}))

interface V2L3WorkItemNotReadyDetailProps {
	title: string
	error: FusionError
}

export const V2L3WorkItemNotReadyDetail = ({
	title,
	error,
}: V2L3WorkItemNotReadyDetailProps) => {
	return (
		<V2L2WorkItemDetailRoot>
			<V2L2WorkItemDetailTitle ready={false}>
				<FontAwesomeIcon icon={faExclamationTriangle} />
				{title}
			</V2L2WorkItemDetailTitle>
			<V2L2WorkItemDetailContent>
				<V2L2WorkItemDetailContentItem label="Error" span={3}>
					Unable to load work item; please contact support.
				</V2L2WorkItemDetailContentItem>
				<V2L2WorkItemDetailContentItem label="Details" span={3}>
					<ErrorBlock>[{error.name}]{`\n`}{error.message}</ErrorBlock>
				</V2L2WorkItemDetailContentItem>
			</V2L2WorkItemDetailContent>
		</V2L2WorkItemDetailRoot>
	)
}
